export default function HomepageFeaturedBadge() {
  return (
    <aside
      aria-label="AriaFlow recognition"
      className="border-t border-zinc-800 bg-zinc-950 px-5 py-6"
    >
      <div className="mx-auto flex max-w-7xl justify-center">
        <a
          href="https://theresanaiforthat.com/ai/ariaflow/?ref=featured&v=6019597"
          target="_blank"
          rel="nofollow"
          aria-label="View AriaFlow on There's An AI For That"
          className="inline-flex rounded-lg opacity-90 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-4 focus-visible:ring-offset-zinc-950"
        >
          {/* The verification crawler expects this external badge URL on the root homepage. */}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            width={300}
            src="https://media.theresanaiforthat.com/featured-on-taaft.png?width=600"
            alt="Featured on There's An AI For That"
            className="h-auto w-[260px] max-w-full sm:w-[300px]"
          />
        </a>
      </div>
    </aside>
  );
}
